import style from './style.css';

const nonApprovedContainer = ({ bicAction }) => {
  return (
    <div className={style.userEligibilityContainer}>
      <div className={style.userEligibilityTextContainer}>
        <div className={style.logoContainer}>
          <img
            src='https://iccdn.in/bic/icons/img-wallet.svg'
            alt='wallet-logo'
          />
        </div>
        <div className={style.textContainer}>
          <span className={style.cardlessEmiText}>
            You are not pre-approved
          </span>{' '}
          We will notify you in the future
        </div>
      </div>
    </div>
  );
};

export default nonApprovedContainer;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/nonApprovedUserCard/nonApprovedContainer/index.js